// extracted by mini-css-extract-plugin
module.exports = {"container":"todo-module--container--8v3Qq","content":"todo-module--content--31hpJ"};